import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Landmark } from "lucide-react";
import { SettlementAccountForm } from "./CapayAccountCard";

const LABELS = { street: "street", city: "suburb/city", state: "state", zip: "postcode", beneficial_owner_name: "director", register_date: "registration date", abn: "ABN", legal_name: "registered name", business_type: "business type" };

/** Money-out gate (nominal / disbursement) refused with `capay_va_required`
 *  → complete the customer's details here and create the Capay settlement account. */
export function SettlementAccountDialog({ gate, user, applicationId, onClose, onCreated }) {
  if (!gate) return null;
  const initial = gate.form || {};
  const missing = (gate.missing_fields || []).map((k) => LABELS[k] || k);
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-2xl" data-testid="settlement-account-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><Landmark className="w-5 h-5 text-emerald-700" />Settlement account needed — {gate.sf_number}</DialogTitle>
          <DialogDescription data-testid="settlement-account-dialog-msg">
            {gate.message || "The customer's Capay settlement (repayment) account must exist before money is sent."}
            {missing.length ? ` Still missing: ${missing.join(", ")}.` : ""}
          </DialogDescription>
        </DialogHeader>
        <SettlementAccountForm key={gate.sf_number} sfNumber={gate.sf_number} initial={initial} user={user}
          applicationId={applicationId} onAccount={(acc) => onCreated(acc)} />
      </DialogContent>
    </Dialog>
  );
}

/** Pull the structured gate detail out of an axios error, or null. */
export function settlementGateFromError(error) {
  const d = error?.response?.data?.detail;
  if (d && typeof d === "object" && (d.code === "capay_va_required" || d.code === "capay_va_create_failed")) return d;
  return null;
}

export function errorDetailText(error, fallback) {
  const d = error?.response?.data?.detail;
  if (!d) return fallback;
  if (typeof d === "string") return d;
  return d.message || JSON.stringify(d);
}
